skipStandbyResult